import { Files } from '../../lib/constants/files'
import { HobbyInput } from '../../lib/types/models/hobby/hobby-input'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateHobby(data: UpdateInput<HobbyInput>) {
  const { id, ...rest } = data
  // If picto is provided, upload it
  if (rest.picto) {
    const uploadedFile = await uploadFile(Files.HOBBY_PICTO, rest.picto)
    if (uploadedFile) rest.picto = uploadedFile
    else throw new Error('File not uploaded')
  }
  return restApiClient.url(constructApiUrl(API.hobbies.update.url, { id })).patch(rest)
}
